import React, { useState, useEffect } from "react";
import { Link, useLocation,Navigate  } from "react-router-dom";
import { removeUserSession, chkMenu } from '../Utils/Common';

const items = [
  { path: "overview", name: "Overview", image: "assests/images/si-1.png" },
  { path: "profile", name: "Profile", image: "assests/images/profile_menu.png" },
  {
    path: "merchant-overview",
    name: "Merchants",
    image: "assests/images/si-2.png",
    children: [
      { path: "dashboard-overview-merchants-information", name: "Merchant Information" },
      { path: "merchant-subscription", name: "Merchant Subscription" }
    ]
  },
  { path: "employee-overview", name: "Employment", image: "assests/images/si-33.png" }, 
  { path: "dashboard-sales-vp-of-sales-representative", 
    name: "Sales", 
    headerName: "Sales",
    image: "assests/images/si-3.png", 
    children: [
      { path: "salesperson-Information", name: "Sales", headerName: "Salesperson Information" },
    ] 
  },
  { path: "customer-overview", 
    name: "Customers",
    headerName: "Customer Overview",
    image: "assests/images/si-4.png",
    children: [
      { path: "dashboard-customer2", name: "Customers2"},
    ]
  },
  { path: "customer-service", name: "Customer Service", image: "assests/images/si-5.png" },
  { path: "hr-creation", 
    name: "HR", 
    image: "assests/images/si-6.png", 
    headerName: "Overview HR", 
    children: [
      { path: "create-account", name: "HR"},
      { path: "view-account-management", name: "HR"},
    ]
  },
  { path: "adminstrator", 
    name: "Administrator", 
    image: "assests/images/si-7.png",
    children: [
      { path: "dashboard-merchants-employees", name: "Dashboard Merchants Employees"},
    ] 
  },
];

const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen((prevState) => !prevState);
  };
  const isActive = (item) => {
    const currentPath = location.pathname;

    if (!item.children) {
      return currentPath === `/${item.path}`;
    }
    if (currentPath === `/${item.path}`) {
      return true;
    }

    if(item.path==='dashboard-sales-vp-of-sales-representative')
    { 
      let department = parseInt(localStorage.getItem("department"));
      if(department===2)
      {
         if(currentPath==='/merchant-subscription')
         {
            return true;
         }
      }
    }
    if(item.path==='merchant-overview')
    { 
      let department = parseInt(localStorage.getItem("department"));
      if(department===3)
      {
         if(currentPath==='/dashboard-customer2')
         {
            return true;
         }
      }
    }
    if(item.path==='customer-overview')
    { 
      let department = parseInt(localStorage.getItem("department"));
      if(department===4)
      {
         if(currentPath==='/merchant-subscription')
         {
            return true;
         }
      }
    }

    if(item.path==='profile')
    { 
        let department = parseInt(localStorage.getItem("department"));
        if(department===7)
        { if(currentPath==='/profile-sub')
          {
            return true;
          }
        }
    }

    if (item.children) {
      return item.children.some((child) => currentPath === `/${child.path}`);
    }    
    return false;
  };

  useEffect(() => {
    const currentPath = location.pathname;
  
    const matchItem = items.find((item) => {
      if (item.children) {
        if (currentPath === `/${item.path}`) return true;
  
        const matchedChild = item.children.find(
          (child) => currentPath === `/${child.path}`
        );
        if (matchedChild) {
          const merged = {
            ...item,
            name: matchedChild.name,
            headerName: matchedChild.headerName || item.headerName,
          };
          localStorage.setItem("activeItem", JSON.stringify(merged));
          return true;
        }
      }
  
      if (currentPath === `/${item.path}`) return true;
  
      return false;
    });
  
    // Store if it's a direct match (not from child)
    if (matchItem && !matchItem.children?.some(child => `/${child.path}` === currentPath)) {
      localStorage.setItem("activeItem", JSON.stringify(matchItem));
    }
  
    document.title = `Sidebar | bluefaucet`;
    document.getElementById("bodywrap").className = "sidu";
  }, [location.pathname]);   
  
/* Start logout */
const logout = () => {
    removeUserSession();
    //window.location.href = "/";
    <Navigate to="/" />
}
/* End logout */

  const renderSidebarItems = () => (
  <>
    {/*{items.map((item) => (
      <Link
        key={item.path}
        to={`${process.env.REACT_APP_BASE_URL}${item.path}`}
        className="text-decoration-none"
        onClick={() => setIsOpen(false)}
      >
        <div className={`sidebar-item mb-3 ${isActive(item) ? "active" : ""}`}>
          <img
            src={`${process.env.REACT_APP_BASE_URL}${item.image}`}
            alt={item.name}
            className="img-fluid"
          />
          <span>{item.name}</span>
        </div>
      </Link>
    ))}*/}
{chkMenu('overview') === 1 && (<Link
  to={`${process.env.REACT_APP_BASE_URL}overview`}
  className="text-decoration-none"
  onClick={() => setIsOpen(false)}
  >
  <div className={`sidebar-item mb-3 ${isActive({ path: "overview", name: "Overview", image: "assests/images/si-1.png" }) ? "active" : ""}`}>
  <img
    src={`${process.env.REACT_APP_BASE_URL}assests/images/si-1.png`}
    alt="Overview"
    className="img-fluid"
  />
  <span>Overview</span>
  </div>
</Link>)}
{parseInt(localStorage.getItem("department")) !== 7 ? (
<Link
  to={`${process.env.REACT_APP_BASE_URL}profile`}
  className="text-decoration-none"
  onClick={() => setIsOpen(false)}
  >
  <div className={`sidebar-item mb-3 ${isActive({ path: "profile", name: "Profile", image: "assests/images/si-1.png" }) ? "active" : ""}`}>
  <img
    src={`${process.env.REACT_APP_BASE_URL}assests/images/profile_menu.png`}
    alt="Profile"
    className="img-fluid"
  />
  <span>Profile</span>
  </div>
</Link>
) : (
  <Link
  to={`${process.env.REACT_APP_BASE_URL}profile-sub`}
  className="text-decoration-none"
  onClick={() => setIsOpen(false)}
  >
  <div className={`sidebar-item mb-3 ${isActive({ path: "profile-sub", name: "Profile", image: "assests/images/si-1.png" }) ? "active" : ""}`}>
  <img
    src={`${process.env.REACT_APP_BASE_URL}assests/images/profile_menu.png`}
    alt="Profile"
    className="img-fluid"
  />
  <span>Profile</span>
  </div>
</Link>
)}
{chkMenu('merchant-overview') === 1 && (<Link
  to={`${process.env.REACT_APP_BASE_URL}merchant-overview`}
  className="text-decoration-none"
  onClick={() => setIsOpen(false)}
  >
  <div className={`sidebar-item mb-3 ${isActive({
    path: "merchant-overview",
    name: "Merchants",
    image: "assests/images/si-2.png",
    children: [
      { path: "dashboard-overview-merchants-information", name: "Merchant Information" },
      { path: "merchant-subscription", name: "Merchant Subscription" }
    ]
  }) ? "active" : ""}`}>
    <img
      src={`${process.env.REACT_APP_BASE_URL}assests/images/si-2.png`}
      alt="Merchants"
      className="img-fluid"
    />
    <span>Merchants</span>
  </div>
  </Link>)}
 {chkMenu('employee-overview') === 1 && (<Link
        to={`${process.env.REACT_APP_BASE_URL}employee-overview`}
        className="text-decoration-none"
        onClick={() => setIsOpen(false)}
      >
        <div className={`sidebar-item mb-3 ${isActive({ path: "employee-overview", name: "Employment", image: "assests/images/si-33.png" }) ? "active" : ""}`}>
          <img
            src={`${process.env.REACT_APP_BASE_URL}assests/images/si-33.png`}
            alt="Employment"
            className="img-fluid"
          />
          <span>Employment</span>
        </div>
      </Link>)}

{chkMenu('dashboard-sales-vp-of-sales-representative') === 1 && (<Link
        to={`${process.env.REACT_APP_BASE_URL}dashboard-sales-vp-of-sales-representative`}
        className="text-decoration-none"
        onClick={() => setIsOpen(false)}
      >
        <div className={`sidebar-item mb-3 ${isActive({ path: "dashboard-sales-vp-of-sales-representative", 
    name: "Sales", 
    headerName: "Sales",
    image: "assests/images/si-3.png", 
    children: [
      { path: "salesperson-Information", name: "Sales", headerName: "Salesperson Information" },
    ] 
  }) ? "active" : ""}`}>
          <img
            src={`${process.env.REACT_APP_BASE_URL}assests/images/si-3.png`}
            alt="Sales"
            className="img-fluid"
          />
          <span>Sales</span>
        </div>
      </Link>)}

{chkMenu('customer-overview') === 1 && (<Link
        to={`${process.env.REACT_APP_BASE_URL}customer-overview`}
        className="text-decoration-none"
        onClick={() => setIsOpen(false)}
      >
        <div className={`sidebar-item mb-3 ${isActive({ path: "customer-overview", 
    name: "Customers",
    headerName: "Customer Overview",
    image: "assests/images/si-4.png",
    children: [
      { path: "dashboard-customer2", name: "Customers2"},
    ]
  }) ? "active" : ""}`}>
          <img
            src={`${process.env.REACT_APP_BASE_URL}assests/images/si-4.png`}
            alt="Customers"
            className="img-fluid"
          />
          <span>Customers</span>
        </div>
      </Link>)}


{chkMenu('customer-service') === 1 && (<Link
        to={`${process.env.REACT_APP_BASE_URL}customer-service`}
        className="text-decoration-none"
        onClick={() => setIsOpen(false)}
      >
        <div className={`sidebar-item mb-3 ${isActive({ path: "customer-service", name: "Customer Service", image: "assests/images/si-5.png" }) ? "active" : ""}`}>
          <img
            src={`${process.env.REACT_APP_BASE_URL}assests/images/si-5.png`}
            alt="Customer Service"
            className="img-fluid"
          />
          <span>Customer Service</span>
        </div>
      </Link>)}

{chkMenu('hr-creation') === 1 && (<Link
        to={`${process.env.REACT_APP_BASE_URL}hr-creation`}
        className="text-decoration-none"
        onClick={() => setIsOpen(false)}
      >
        <div className={`sidebar-item mb-3 ${isActive({ path: "hr-creation", 
    name: "HR", 
    image: "assests/images/si-6.png", 
    headerName: "Overview HR", 
    children: [
      { path: "create-account", name: "HR"},
      { path: "view-account-management", name: "HR"},
    ]
  }) ? "active" : ""}`}>
          <img
            src={`${process.env.REACT_APP_BASE_URL}assests/images/si-5.png`}
            alt="HR"
            className="img-fluid"
          />
          <span>HR</span>
        </div>
      </Link>)}

{chkMenu('adminstrator') === 1 && (<Link
        to={`${process.env.REACT_APP_BASE_URL}adminstrator`}
        className="text-decoration-none"
        onClick={() => setIsOpen(false)}
      >
        <div className={`sidebar-item mb-3 ${isActive({ path: "adminstrator", 
    name: "Administrator", 
    image: "assests/images/si-7.png",
    children: [
      { path: "dashboard-merchants-employees", name: "Dashboard Merchants Employees"},
    ] 
  }) ? "active" : ""}`}>
          <img
            src={`${process.env.REACT_APP_BASE_URL}assests/images/si-7.png`}
            alt="Administrator"
            className="img-fluid"
          />
          <span>Administrator</span>
        </div>
      </Link>)}
    <Link
      to="#" // or use onClick for logout
      className="text-decoration-none"
      onClick={logout}
    >
      <div className="sidebar-item mb-3">
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/logout.png'}
          alt="Logout"
          className="img-fluid"
        />
        <span>Logout</span>
      </div>
    </Link>
  </>
);
  
  return (
    <>
      <div className="col-md-3 col-lg-3 col-xl-2 col-xxl-2 px-0">
        <div className="mobile-header d-flex justify-content-between align-items-center p-3 d-md-none">
          <img
            src={process.env.REACT_APP_BASE_URL + 'assests/images/blue-side.png'}
            alt="BlueFaucet Logo"
            className="img-fluid"
            style={{ height: "40px" }}
          />
          <img
            src={process.env.REACT_APP_BASE_URL + '/assests/images/toggle.png'}
            alt="Menu"
            onClick={toggleSidebar}
            style={{ height: "30px", cursor: "pointer" }}
          />
        </div>

        <div
          className={`sidebar ${
            isOpen ? "open" : ""
          } d-none d-md-block d-lg-block`}
        >
          <div className="main-image mb-5 mt-4">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/blue-side.png'}
              alt="BlueFaucet Logo"
              className="img-fluid"
            />
          </div>
          {renderSidebarItems()}
        </div>
      </div>

      {isOpen && (
        <div className="sidebar mobile-sidebar d-md-none h-100">
          {renderSidebarItems()}
        </div>
      )}
    </>
  );
};

export default Sidebar;
